<script>
	import { Router, Link, Route } from 'svelte-routing'
	import dialogPolyfill from 'dialog-polyfill'
	import Home from './routes/Home.svelte'
	import 'dialog-polyfill/dist/dialog-polyfill.css'
	import Danse from './routes/Danse.svelte'
	import Yoga from './routes/Yoga.svelte'
	import Massage from './routes/Massage.svelte'
	import Stretching from './routes/Stretching.svelte'
	import Other from './routes/Other.svelte'

	export let url = ''
	const routes = [
		{ name: 'Danse', path: 'dance', component: Danse },
		{ name: 'Yoga', path: 'yoga', component: Yoga },
		{ name: 'Étirements/Renforcements', path: 'stretching', component: Stretching },
		{ name: 'Massages', path: 'massages', component: Massage },
		{ name: 'Autres', path: 'other', component: Other }
	]
</script>
<style>
 	@font-face {
		font-family: "graffiti";
		src: url("font.ttf") format("truetype")
	}
	@font-face {
		font-family: "TheAustin";
		src: url("TheAustin.ttf") format("truetype")
	}

	h2 {
		margin: 0;
	}
	a { text-decoration: none }
	#menu {
		display: flex;
		flex-wrap: wrap;
		margin: 0;
		justify-content: center;
		list-style-type: none;
		padding: 0;
		font-variant: small-caps;
		font-weight: bold;
		font-size: 2rem;
	}

	:global(#menu a) {
		margin: 10px 30px;
		text-decoration: none;
		color: inherit;
	}
	
	#title {
		cursor: pointer;
		margin: 0;
		text-align: center;
		left: 38px;
		font-size: 5rem;
		font-weight: normal;
	}
	#title h2 {
		font-size: 17px;
		font-family: none;
		font-style: italic;
		position: relative;
		top: -10px;
	}
	#prenom {
		display: inline;
		font-family: TheAustin;
	}
	#nom {
		color: #CB3082;
		display: inline;
		margin-left: 10px;
		font-weight: 100;
		font-size: 4.6rem;
	}
	@media only screen and (max-width: 600px) {
		body {
			font-size: 1.2rem;
		}
		#prenom {
			display: block;
		}
		#nom {
			display: block;
			position: relative;
			margin-left: 0;
			top: -35px;
		}
		#title h2 {
			top: -45px
		}
		#menu {
			font-size: 1.5rem;
		}
	}
</style>
<Router url="{url}">
	<Link
		to="/"
		getProps="{() =>({ style: 'text-decoration: none; color: inherit'})}"
	>
		<div id="title"><div id="prenom">Mélinda</div><div id="nom">Glikmans</div><h2>Dance, art, sport and well-being</h2></div>
	</Link>
	<div id="menu">
		{#each routes as route}
			<Link to="{route.path}">{route.name}</Link>
		{/each}
	</div>
	<Route path="/" component="{Home}"></Route>
	{#each routes as route}
		<Route path="{route.path}" component="{route.component}"></Route>
	{/each}
</Router>
<!-- 
{:else if currentTab === 'Danse'}
	
	{:else if currentTab === 'Yoga'}
	<div id="main">
		<p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dolor esse enim ratione cupiditate eligendi ullam nulla quasi iste voluptatum accusantium, quaerat saepe beatae, porro voluptatem! Error repellendus illum magni quos. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Consequuntur illum expedita distinctio temporibus earum ratione repellat pariatur, beatae cumque laudantium ducimus commodi eius quam fugit numquam aut qui unde tempora.</p>
		<img src="yoga.png" alt="" style="display: block; width: 350px; box-shadow: 0px 0px 5px 0px #333232">
	</div>
{/if} -->
